module.exports = __webpack_public_path__ + "img/bio-icon-dark.00f7c97e.png";